interface IconBoltFilledProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconBoltFilled
 */
const IconBoltFilled = ({ size = 48, color = '#AE0A10', className }: IconBoltFilledProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_93_9673)">
      <path
        fill={color}
        d="M26.5 4L26.536 4.002L26.568 4.004L26.734 4.014L26.756 4.018H26.778L26.854 4.036L26.958 4.052L26.99 4.064L27.012 4.066L27.07 4.088L27.174 4.116L27.212 4.134L27.242 4.142L27.298 4.17L27.378 4.204L27.42 4.228L27.464 4.248L27.51 4.278L27.572 4.312L27.64 4.36L27.676 4.382L27.702 4.406L27.75 4.44L27.826 4.508L27.87 4.542L27.886 4.562L27.914 4.586L27.986 4.668L28.038 4.722L28.05 4.74C28.29 5.034 28.442 5.384 28.486 5.766L28.488 5.79L28.492 5.872L28.5 6V18H38.5C38.8505 17.9999 39.1949 18.092 39.4987 18.2669C39.8024 18.4418 40.0549 18.6935 40.2307 18.9968C40.4065 19.3 40.4996 19.6442 40.5005 19.9947C40.5014 20.3452 40.4102 20.6898 40.236 20.994L40.116 21.176L24.116 43.176C22.98 44.742 20.5 43.936 20.5 42V30H10.5C10.1495 30.0001 9.80509 29.908 9.50133 29.7331C9.19758 29.5582 8.94515 29.3065 8.76932 29.0032C8.59349 28.7 8.50045 28.3558 8.49952 28.0053C8.49859 27.6548 8.5898 27.3102 8.76401 27.006L8.88401 26.824L24.884 4.824L24.904 4.798L24.94 4.75L25.006 4.674L25.042 4.63L25.06 4.614L25.086 4.586L25.166 4.514L25.222 4.462L25.238 4.45C25.4724 4.25816 25.7473 4.12207 26.042 4.052L26.064 4.05L26.118 4.04L26.266 4.014L26.288 4.012L26.37 4.008L26.5 4Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9673">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconBoltFilled;
